



















import { Vue, Component } from "vue-property-decorator";
import Button from "@/form/Button.vue";
import AlertInfo from "@/components/AlertInfo.vue";
@Component({
	components: { Button, AlertInfo },
})
export default class Banner extends Vue {
	private url: string | null = null;
	private email: string | null = null;

	async mounted() {
		const constants = await import(
			`@` + `/themes/${process.env.VUE_APP_BRAND}/constants.json`
		);

		if (window.location.hostname.includes("superconnector.iress.com")) {
			if (window.location.hostname.includes("uat")) {
				this.url = constants.uatUrl;
			} else {
				this.url = constants.prodUrl;
			}
		}
		this.email = constants.email;
	}

	private isNewUrl() {
		return window.location.hostname.includes("apexsuper");
	}

	private message() {
		return `
		To access SuperConnector please go to ${
			this.url ? this.url : "[website is not supported]"
		} and login.

		Your email address and password have not changed.

		Please ensure you update your favourites and bookmarks for future use.

		Need help?
		Contact ${this.email}`;
	}

	private brand() {
		return process.env.VUE_APP_BRAND;
	}
}
